interface TourProductSectionProps {
  order: {
    id: string;
    title: string;
    coverImage?: string;
    days: number;
    nights: number;
    tags: string[];
    startDate: string;
    endDate: string;
    travelers: number;
    travelersText: string;
    pickup: string;
    contactName: string;
    contactPhone: string;
    contactEmail: string;
    roomType: string;
    roomUnitPrice: string;
    pickup: string;
    destinations: string;
  };
  onAction: (a: string) => void;
}

const BRAND = "#FF6B35";

export default function TourProductSection({ order, onAction }: TourProductSectionProps) {
  const coverSrc = order.coverImage || "https://readdy.ai/api/search-image?query=Sanya%20Wuzhizhou%20Island%20crystal%20clear%20turquoise%20water%20aerial%20view%20tropical%20paradise&width=400&height=200&seq=sod002&orientation=landscape";

  const routeText = [order.pickup, order.destinations].filter(Boolean).join(" → ") || "—";
  const infoItems = [
    { icon: "ri-calendar-line", label: "出行日期", value: order.startDate || "—" },
    { icon: "ri-calendar-check-line", label: "返程日期", value: order.endDate || "—" },
    { icon: "ri-user-3-line", label: "出行人数", value: order.travelersText || `${order.travelers}人` },
  ];

  return (
    <div className="mx-4 mt-3 bg-white rounded-2xl overflow-hidden">
      {/* 封面图 */}
      <div className="relative h-48" style={{ background:"linear-gradient(180deg,#0EA5E9,#2563EB)" }}>
        <img
          src={coverSrc}
          alt={order.title} className="w-full h-full object-cover"
        />
      </div>
      <div className="px-4 py-4">
        {/* 标签 + 标题 */}
        <div className="flex items-center gap-2 mb-2 flex-wrap">
          <span
            className="text-xs font-semibold px-2.5 py-1 rounded-full whitespace-nowrap"
            style={{ background: "#FFF7ED", color: BRAND }}
          >
            {order.days}天{order.nights}晚
          </span>
          {order.tags.map((t) => (
            <span
              key={t}
              className="text-xs font-semibold px-2.5 py-1 rounded-full whitespace-nowrap"
              style={{ background: "#ECFDF8", color: "#059669" }}
            >
              {t}
            </span>
          ))}
        </div>
        <div className="text-base font-bold text-gray-900 leading-tight">{order.title}</div>

        {/* 行程路线 */}
        <div
          className="mt-3 p-3 rounded-xl flex items-center gap-2.5"
          style={{ background: "#F0FDF4" }}
        >
          <i className="ri-flight-takeoff-line" style={{ color: "#16A34A", fontSize: 15 }} />
          <span className="text-xs text-gray-600">{routeText}</span>
        </div>

        {/* 日期 / 人数 */}
        <div className="mt-3 grid grid-cols-2 gap-3">
          {infoItems.map((item) => (
            <div
              key={item.label}
              className="flex items-center gap-2.5 p-2.5 rounded-xl"
              style={{ background: "#F9FAFB" }}
            >
              <div
                className="w-8 h-8 rounded-lg flex items-center justify-center flex-shrink-0"
                style={{ background: "#FFF7ED" }}
              >
                <i className={item.icon} style={{ color: BRAND, fontSize: 15 }} />
              </div>
              <div className="min-w-0">
                <div className="text-[11px] text-gray-400">{item.label}</div>
                <div className="text-xs font-medium text-gray-800 truncate">{item.value}</div>
              </div>
            </div>
          ))}
        </div>

        {/* 已选档次 */}
        {order.roomType && (
          <div
            className="mt-3 p-3 rounded-xl flex items-center justify-between"
            style={{ background: "linear-gradient(135deg, #FFF7ED 0%, #FFF0F5 100%)" }}
          >
            <div className="flex items-center gap-2.5">
              <div
                className="w-8 h-8 rounded-lg flex items-center justify-center flex-shrink-0"
                style={{ background: "rgba(249,115,22,0.12)" }}
              >
                <i className="ri-vip-crown-line" style={{ color: BRAND, fontSize: 15 }} />
              </div>
              <div>
                <div className="text-[11px] text-gray-500">已选档次</div>
                <div className="text-sm font-bold text-gray-900">{order.roomType}</div>
              </div>
            </div>
            <div className="text-right">
              <div className="text-sm font-bold" style={{ color: BRAND }}>¥{order.roomUnitPrice}</div>
              <div className="text-[10px] text-gray-400">/人</div>
            </div>
          </div>
        )}

        {/* 联系人卡片 */}
        <div className="mt-3 p-3 rounded-xl" style={{ background: "#F9FAFB" }}>
          <div className="text-[11px] text-gray-400 mb-2 flex items-center gap-1">
            <i className="ri-contacts-line" style={{ color: BRAND }} />
            联系人信息
          </div>
          <div className="space-y-2 text-xs">
            <div className="flex items-center justify-between">
              <span className="text-gray-500">姓名</span>
              <span className="font-medium text-gray-800">{order.contactName || "—"}</span>
            </div>
            <div className="flex items-center justify-between">
              <span className="text-gray-500">电话</span>
              <span className="font-medium text-gray-800">{order.contactPhone || "—"}</span>
            </div>
            {order.contactEmail && (
              <div className="flex items-center justify-between">
                <span className="text-gray-500">邮箱</span>
                <span className="font-medium text-gray-800 break-all text-right">{order.contactEmail}</span>
              </div>
            )}
          </div>
        </div>

        {/* 行程中操作按钮 */}
        {/* 可根据 subStatus 条件渲染 */}
      </div>
    </div>
  );
}

